import React, { useState, useRef } from 'react';
import { FiChevronDown } from "react-icons/fi";
import userPlaceholder from '../../../../assets/profile/placeholder.png';
import { uploadFiles } from '../../../../_config/apiClient';

const ProfileEdit = ({ data, onSave, onCancel }) => {
    const [formData, setFormData] = useState({ ...data });
    const fileInputRef = useRef(null);
    const [uploadingImage, setUploadingImage] = useState(false);
    const [fieldStatus, setFieldStatus] = useState({});


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleFileChange = async (e) => {
        try {
            const file = e.target.files[0];
            if (!file) return;

            setUploadingImage(true);
            setFieldStatus((prev) => ({ ...prev, image: "uploading" }));

            const { data } = await uploadFiles({ files: [file] });

            setFormData((prev) => ({
                ...prev,
                image: data[0].imageUrl,
            }));

            setFieldStatus((prev) => ({ ...prev, image: "updated" }));

            // auto hide message
            setTimeout(() => {
                setFieldStatus((prev) => ({ ...prev, image: null }));
            }, 2000);
        } catch (error) {
            console.error("File upload error:", error);
            setFieldStatus((prev) => ({ ...prev, image: "error" }));
        } finally {
            setUploadingImage(false);
        }
    };

    const labelClass = "w-full sm:w-[180px] sm:text-right text-[15px] md:text-[18px] tracking-tight font-[500] text-[#000000] shrink-0";
    const inputClass = "w-full border-b border-[#000000] py-2 outline-none text-[14px] md:text-[15px] font-medium bg-transparent focus:border-[#4096F6] transition-all placeholder:text-[#333333CC] text-[#333333CC]";

    return (
        <div className="bg-white rounded-[10px] border border-[#E0E0E0] p-6 md:p-12 min-h-auto md:min-h-[550px] shadow-sm animate-in fade-in duration-500">
            <div className="max-w-[750px] mx-auto text-left relative">
                <button className="absolute right-0 md:-right-10 -top-2 md:top-0 text-[#4096F6] font-[500] text-[14px] md:text-[18px] hover:underline">
                    Edit
                </button>

                <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    className="hidden"
                    accept="image/*"
                />

                <div className="flex flex-col gap-8 md:gap-10">
                    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-10 md:ml-14">
                        <span className={labelClass}>Profile Picture :</span>
                        <div className="flex items-center gap-4 relative">
                            <div className="relative">
                                <img
                                    src={formData.image || userPlaceholder}
                                    alt="User"
                                    className={`w-[55px] h-[55px] md:w-[68px] md:h-[68px] rounded-full object-cover border border-gray-100 shadow-sm
        ${uploadingImage ? "opacity-60" : ""}`}
                                />

                                {uploadingImage && (
                                    <div className="absolute inset-0 flex items-center justify-center">
                                        <div className="w-6 h-6 border-2 border-[#4096F6] border-t-transparent rounded-full animate-spin"></div>
                                    </div>
                                )}
                            </div>

                            <button
                                type="button"
                                onClick={() => fileInputRef.current.click()}
                                className="text-[#4096F6] font-[500] text-[13px] md:text-[18px] hover:underline"
                            >
                                Change
                            </button>
                        </div>

                        {fieldStatus.image === "updated" && (
                            <p className="text-green-600 text-[12px] mt-1">
                                Profile picture updated
                            </p>
                        )}

                    </div>

                    <div className="flex flex-col gap-6 md:gap-8 md:ml-14 md:pr-10">
                        {/* Full Name */}
                        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-1 sm:gap-10">
                            <label className={labelClass}>Full Name :</label>
                            <input
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                type="text"
                                className={inputClass}
                            />
                        </div>

                        {/* Date of Birth */}
                        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-1 sm:gap-10 relative">
                            <label className={labelClass}>Date Of birth :</label>
                            <div className="w-full relative hdhub">
                                <input
                                    name="dob"
                                    value={formData.dob}
                                    onChange={handleChange}
                                    type="date"
                                    placeholder="dd-mm-yy"
                                    className={inputClass}
                                />
                                {/* <FiCalendar className="absolute right-0 top-1/2 -translate-y-1/2 text-[18px] text-[#333] pointer-events-none" /> */}
                            </div>
                        </div>

                        {/* Education Dropdown */}
                        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-1 sm:gap-10 relative">
                            <label className={labelClass}>Education :</label>
                            <div className="w-full relative">
                                <select
                                    name="education"
                                    value={formData.education}
                                    onChange={handleChange}
                                    className={`${inputClass} appearance-none cursor-pointer`}
                                >
                                    <option value="">Your Degree</option>
                                    <option value="Graduate">Graduate</option>
                                    <option value="Post Graduate">Post Graduate</option>
                                    <option value="High School">High School</option>
                                </select>
                                <FiChevronDown className="absolute right-0 top-1/2 -translate-y-1/2 text-[20px] text-[#333] pointer-events-none" />
                            </div>
                        </div>

                        {/* Category Dropdown */}
                        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-1 sm:gap-10 relative">
                            <label className={labelClass}>Category :</label>
                            <div className="w-full relative">
                                <select
                                    name="category"
                                    value={formData.category}
                                    onChange={handleChange}
                                    className={`${inputClass} appearance-none cursor-pointer`}
                                >
                                    <option value="">Your Category</option>
                                    <option value="General">General</option>
                                    <option value="OBC">OBC</option>
                                    <option value="SC/ST">SC/ST</option>
                                </select>
                                <FiChevronDown className="absolute right-0 top-1/2 -translate-y-1/2 text-[20px] text-[#333] pointer-events-none" />
                            </div>
                        </div>

                        {/* Location */}
                        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-1 sm:gap-10">
                            <label className={labelClass}>Address :</label>
                            <input
                                name="location"
                                value={formData.location}
                                onChange={handleChange}
                                type="text"
                                placeholder="Address, City, State"
                                className={inputClass}
                            />
                        </div>

                        {/* Mobile Number */}
                        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-1 sm:gap-10">
                            <label className={labelClass}>Mobile Number :</label>
                            <input
                                name="phone"
                                value={formData.phone}
                                disabled
                                onChange={handleChange}
                                type="text"
                                placeholder="+91"
                                className={inputClass}
                            />
                        </div>

                        {/* Email Id */}
                        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-1 sm:gap-10">
                            <label className={labelClass}>Email Id :</label>
                            <input
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                type="email"
                                placeholder="Enter Email"
                                className={inputClass}
                            />
                        </div>
                    </div>

                    {/* Action Buttons*/}
                    <div className="flex flex-col items-center gap-4 mt-8 md:mt-12 px-4">
                        <button
                            type="button"
                            onClick={() => onSave(formData)}
                            className="w-full sm:w-auto bg-[#4096F6] text-white sm:px-24 py-3 rounded-[4px] font-[500] tracking-tight text-[16px] md:text-[18px] shadow-md hover:bg-[#3488e5] transition-all"
                        >
                            Save Profile
                        </button>
                        <button
                            type="button"
                            onClick={onCancel}
                            className="text-gray-400 font-medium hover:text-gray-600 transition-colors text-[14px] md:text-[16px]"
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfileEdit;